const ACTION_COLORS: Record<string, string> = {
  pass: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300',
  shot: 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300',
  carry: 'bg-indigo-100 dark:bg-indigo-900/40 text-indigo-800 dark:text-indigo-300',
  duel: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300',
  ground_duel: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300',
  aerial_duel: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300',
  interception: 'bg-orange-100 dark:bg-orange-900/40 text-orange-800 dark:text-orange-300',
  clearance: 'bg-orange-50 dark:bg-orange-900/20 text-orange-700 dark:text-orange-400',
  touch: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
  free_kick: 'bg-teal-100 dark:bg-teal-900/30 text-teal-800 dark:text-teal-300',
  corner: 'bg-teal-50 dark:bg-teal-900/20 text-teal-700 dark:text-teal-400',
  goal_kick: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
  throw_in: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
  foul: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300',
  infraction: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300',
};

export const getActionColor = (action: string): string => {
  return ACTION_COLORS[action] || 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300';
};

export const formatZone = (zone?: string): string => {
  if (!zone) return '';
  return zone.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};

export const formatAction = (action: string): string => {
  return action.replace(/_/g, ' ');
};

export const getZoneLabel = (x: number, y: number): string => {
  let xZone: string, yZone: string;
  if (x < 33) xZone = 'def';
  else if (x < 67) xZone = 'mid';
  else xZone = 'att';
  if (y < 33) yZone = 'left';
  else if (y < 67) yZone = 'center';
  else yZone = 'right';
  return `${xZone}-${yZone}`;
};

// SVG color palette for pitch visualization (raw hex values for SVG fill/stroke)
export const SVG_COLORS: Record<string, string> = {
  pass: '#3b82f6',
  carry: '#6366f1',
  shot: '#22c55e',
  goal: '#22c55e',
  duel: '#f59e0b',
  ground_duel: '#f59e0b',
  aerial_duel: '#f59e0b',
  interception: '#f97316',
  clearance: '#f97316',
  free_kick: '#14b8a6',
  corner: '#14b8a6',
  foul: '#ef4444',
  infraction: '#ef4444',
  default: '#9ca3af',
};

export const getSvgColor = (action: string, actionDetail?: string): string => {
  if (actionDetail === 'goal') return SVG_COLORS.goal;
  return SVG_COLORS[action] || SVG_COLORS.default;
};

// Map Wyscout coords (0-100, 0-100) to SVG viewBox (0-100, 0-65)
export const toSvgX = (x: number) => x;
export const toSvgY = (y: number) => y * 0.65;
